export const brandLogo = require("./GetGrowCart_Logo.jpg").default;
export const brandLogoLight = require("./GetGrowCart_Logo_Light.jpg").default;
export const brandLogoDark = require("./GetGrowCart_Logo_Dark.jpg").default;
export const brandIcon = require("./GetGrowCart_Icon_Only.jpg").default;

/** Light artwork on a light surface. Dark artwork on a dark surface. */
export function brandLogoForSurface(background) {
  const value = String(background || "").trim();
  const hex = value.startsWith("#") ? value.slice(1) : value;
  if (!/^[0-9a-fA-F]{6}$/.test(hex)) return brandLogoLight;
  const red = parseInt(hex.slice(0, 2), 16);
  const green = parseInt(hex.slice(2, 4), 16);
  const blue = parseInt(hex.slice(4, 6), 16);
  const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;
  return luminance < 0.55 ? brandLogoDark : brandLogoLight;
}
